<template>
  <div class="flex flex-col gap-1 tablet:flex-row">
    <label
      v-for="{ label, price, value } in items"
      :key="label"
      :for="value"
      class="group mb-0 h-[44px] cursor-pointer px-5 py-3.5 text-sm leading-none font-bold text-black italic transition-colors duration-100 hover:bg-mint hover:text-white"
      :class="isSelected(value) ? 'bg-mint text-white' : 'bg-white'"
    >
      <input :id="value" type="radio" class="hidden" :value="value" :checked="isSelected(value)" @change="onChange" />

      <span class="mr-2">{{ label }}</span>

      <span
        v-if="!!price || price === 0"
        :class="{ 'text-white': isSelected(value) }"
        class="text-xs leading-none font-normal text-grey-600 group-hover:text-white tablet:text-sm"
      >
        {{ `${price}€` }}
      </span>
    </label>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import { JOB_OFFER_TYPE } from '@/helpers/constants'
import { priceWithDiscount } from '@/helpers/pricing'

import { useNewJobStore } from '~/store/newJob'

interface JobWizardStepFeaturesOfferTypesEmits {
  (e: 'update:modelValue', value: string): void
}

interface JobWizardStepFeaturesOfferTypesProps {
  modelValue: string
  featuresLookup: Record<string, number>
}

const emit = defineEmits<JobWizardStepFeaturesOfferTypesEmits>()

const props = defineProps<JobWizardStepFeaturesOfferTypesProps>()

const { t } = useI18n()
const store = useNewJobStore()

const promoCodeDiscount = computed(() => store.promoCodeDiscount)

const items = computed(() => [
  {
    value: JOB_OFFER_TYPE.STANDARD,
    label: t('create.offer_type.standard'),
    price: priceWithDiscount(props.featuresLookup[JOB_OFFER_TYPE.STANDARD], promoCodeDiscount.value),
  },
  {
    value: JOB_OFFER_TYPE.INTERNSHIP,
    label: t('create.offer_type.internship'),
    price: priceWithDiscount(props.featuresLookup[JOB_OFFER_TYPE.INTERNSHIP], promoCodeDiscount.value),
  },
])

const isSelected = (value: string) => props.modelValue === value

const onChange = (event: Event) => {
  const { value } = event.target as HTMLInputElement

  emit('update:modelValue', value)
}
</script>
